import { api, refreshDiamonds } from "./cardStore";
import type { Rarity } from "./stickerStore";

export type ItemKind = "card" | "sticker" | "plate" | "pack";
export type Fees = Record<ItemKind, number>;
export type BoostPlan = { id: string; days: number; price: number };
export type ItemPub = {
  kind: ItemKind;
  ref: string;
  id: string;
  name: string;
  url: string;
  rarity: Rarity;
  back?: string | null;
  frame?: string | null;
  supply?: number | null;
  left?: number | null;
};
export type Listing = {
  id: string;
  seller: string;
  kind: ItemKind;
  ref: string;
  qty: number;
  price: number;
  at: number;
  feePct: number;
  boostUntil: number;
  item: ItemPub;
};
export type Sale = {
  at: number;
  kind: ItemKind;
  name: string;
  qty: number;
  total: number;
  gross?: number;
  fee?: number;
  pct?: number;
};
export type KindStat = { gross: number; fee: number; net: number; count: number };
export type SalesStats = {
  totals: { gross: number; fee: number; net: number; count: number; boostSpent: number };
  byKind: Partial<Record<ItemKind, KindStat>>;
  days: { day: string; net: number; count: number }[];
  recent: {
    at: number;
    kind: ItemKind;
    name: string;
    qty: number;
    gross: number;
    fee: number;
    pct: number;
    net: number;
  }[];
};
export type GiftEntry = {
  id: string;
  from: string;
  kind: ItemKind;
  ref: string;
  name: string;
  qty: number;
  at: number;
  seen: boolean;
  item: ItemPub | null;
};

export const fetchListings = () =>
  api<{ listings: Listing[]; fees: Fees; boosts: BoostPlan[] }>("/market/listings");

export const fetchMine = () =>
  api<{ listings: Listing[]; sales: Sale[] }>("/market/mine", { auth: true });

export const fetchSalesStats = () => api<SalesStats>("/market/stats", { auth: true });

export const listItem = (kind: ItemKind, ref: string, qty: number, price: number) =>
  api<{ ok: boolean; listing: Listing }>("/market/list", {
    method: "POST",
    auth: true,
    body: { kind, ref, qty, price },
  });

export const cancelListing = (id: string) =>
  api<{ ok: boolean }>("/market/cancel", { method: "POST", auth: true, body: { id } });

export async function buyListing(id: string, qty: number) {
  const d = await api<{ ok: boolean; diamonds: number }>("/market/buy", {
    method: "POST",
    auth: true,
    body: { id, qty },
  });
  void refreshDiamonds();
  return d;
}

export async function boostListing(id: string, plan: string) {
  const d = await api<{ ok: boolean; diamonds: number; boostUntil: number }>("/market/boost", {
    method: "POST",
    auth: true,
    body: { id, plan },
  });
  void refreshDiamonds();
  return d;
}

export const sendGift = (kind: string, id: string, to: string, qty = 1) =>
  api<{ ok: boolean; diamonds: number }>("/gifts/send", {
    method: "POST",
    auth: true,
    body: { kind, id, to, qty },
  });

export const fetchInbox = () =>
  api<{ gifts: GiftEntry[]; unseen: number }>("/gifts/inbox", { auth: true });

export const markGiftsSeen = () =>
  api<{ ok: boolean }>("/gifts/seen", { method: "POST", auth: true, body: {} });

/** Atalho "Vender" vindo de outras telas: o TradeMarket abre o modal desse item */
export const sellIntent: { kind?: ItemKind; ref?: string } = {};
